import List from './List.jsx';

export default List;


// WEBPACK FOOTER //
// ./src/components/List/index.jsx